import { Table, Typography } from 'antd'

import useResponsive from '../../hooks/useResponsive'

const { Text } = Typography

const data = [
  {
    membershipType: 'Single',
    description: '(age 18 or over as of Dec 31)',
    returningMemberPrice: 195,
    newMemberPrice: 195,
  },
  {
    membershipType: 'Twosome',
    description: '(two adults from the same household)',
    returningMemberPrice: 295,
    newMemberPrice: 295,
  },
  {
    membershipType: 'Family',
    description: '(3+ members from the same household)',
    returningMemberPrice: 325,
    newMemberPrice: 325,
  },
  {
    membershipType: 'Senior',
    description: '(age 60 or over as of Dec.31)',
    returningMemberPrice: 140,
    newMemberPrice: 140,
  },
  {
    membershipType: 'Student',
    description: '(age 18 or over with student ID)',
    returningMemberPrice: 130,
    newMemberPrice: 130,
  },
  {
    membershipType: 'Junior',
    description: '(ages 5 to 17 as of Dec.31)',
    returningMemberPrice: 95,
    newMemberPrice: 95,
  },
]

const MembershipPrices = () => {
  const bp = useResponsive()

  const columns = [
    {
      title: '',
      render: (text, record) => (
        <>
          <b>{record.membershipType}</b>
          {bp.xs ? <br /> : ' '}
          <Text type="secondary" italic style={{ fontSize: '0.85em' }}>
            {record.description}
          </Text>
        </>
      ),
    },
    // {
    //   title: 'Returning members',
    //   align: 'right',
    //   dataIndex: 'returningMemberPrice',
    //   render: (text, record) => <span style={{ whiteSpace: 'nowrap' }}>${text}</span>,
    // },
    {
      title: 'Price',
      align: 'right',
      dataIndex: 'newMemberPrice',
      render: (text, record) => <span style={{ whiteSpace: 'nowrap' }}>${text}</span>,
    },
  ]
  return <Table className="membershipPricesTable" columns={columns} dataSource={data} size="small" pagination={false} />
}

export default MembershipPrices
